<div class="flex items-center justify-between mb-3">
    <div class="flex items-center">
        <span class="text-xl mr-2">{{ icon }}</span>
        <span class="font-remote font-[600] text-gray-900" [ngClass]="getTitleSizeClass()">{{ title }}</span>
    </div>
    <span *ngIf="showCounter && totalRecords > displayedRecords"
          class="text-[10px] font-inter text-gray-500 bg-white bg-opacity-60 px-2 py-1 rounded">
        {{ displayedRecords }} de {{ totalRecords }}
    </span>
</div>
